module.exports = __webpack_public_path__ + "img/nothing-to-see-here.ea08f8e4.png";